export default {

    SET_SAVE_STATE (state, status) {
        state.saveState = status;
    },
    SET_SEARCHTERM (state, searchTerm) {
        state.searchTerm = searchTerm;
    },
    //////////////////// APP MUTATION ////////////////////

    SET_CURRENT_APPLICATION(state, application) {
        state.currentApplication = application;
    },
    SET_CURRENT_APPLICATION_TAB(state, tab) {
        state.currentApplicationTab = tab;
    },

    // SET_CURRENT_INSTANCE Inutile ??
    SET_CURRENT_INSTANCE(state, instance) {
        state.currentApplication = instance;
    },

    SET_SNACKBAR(state, snackbar) {
        state.snackbar.color = snackbar.color;
        state.snackbar.icon = snackbar.icon;
        state.snackbar.text = snackbar.text;
    },

    SET_DISPLAY_SNACKBAR(state, display) {
        state.displaySnackbar = display;
    },

    SET_WW (state, ww){
        state.ww = ww;
    },
    ADD_MODEL_ERROR (state, data){
        let errors = state.modelsWithError;
        let index = errors.findIndex((item) => {
            // field uid est un uid provisoire utiliser pour retrouver les erreurs lié à ce field
            return item.modelUid === data.modelUid && item.provisionalFieldUid === data.provisionalFieldUid;
        });
        if(index < 0){
            state.modelsWithError.push(data);
        }
    },
    REMOVE_MODEL_ERROR (state, data){
        let errors = state.modelsWithError;
        let index = errors.findIndex((item) => {
            return item.modelUid === data.modelUid && item.provisionalFieldUid === data.provisionalFieldUid;
        });
        if(index >= 0){
            state.modelsWithError.splice(index,1);
        }
    },
    CLEAN_MODEL_ERROR (state){
        this._vm.$set(state, 'modelsWithError', []);
    },
    SET_CURRENT_LOCALE(state, data){
        state.currentLocaleValue = data;
    }

};



// WEBPACK FOOTER //
// ./src/store/mutations.js